// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-fill{border-radius:4px;cursor:pointer;background:linear-gradient(90deg, orangeRed 50%, #f4f6f8 50%);color:#ff4500;background-size:205%;background-position:100%}.btn-error{font-weight:bold;border-color:red;border-width:2px}.btn-fill:disabled,.btn-error:disabled{cursor:not-allowed}.small{font-size:10px}", ""]);
// Exports
module.exports = exports;
